import type { FaireProductEntity } from "../../entity_types/product";

export const p_k8zac7przz: FaireProductEntity = {
  token: "p_k8zac7przz",
  type: "product",
  name: "Cí Cí Chili Oil - Good Food Award Winner!",
  brandToken: "b_cx7uv97v8k",
  brandName: "Like Family",
  imageUrl:
    "https://cdn.faire.com/fastly/d3682cea3e6365ecd2dc4854c6af3fef8e9e9b8e95b1e7040be314a64800bb09.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ae2787e4d8e0712bedfc32439b7d7ba086234f24f38c3a0b12a90e760c604517.jpeg",
    "https://cdn.faire.com/fastly/a58ce36ca38de2ce7e1e3983696c9f139fb4cad01babbca828555d052eb2ca54.jpeg",
    "https://cdn.faire.com/fastly/54ba33802088f75642b979b6527aa285f86169765aa6def2533f41425e507709.jpeg",
    "https://cdn.faire.com/fastly/5679a7fe8f53f38822c10cd0aadf155df82ea19b811602f8f8df36f8cc22410b.jpeg",
    "https://cdn.faire.com/fastly/9f6668fc4c7ab061958b0df745d26894d6b31d81a6bf10478290a189e838c64c.jpeg",
  ],
  priceDollars: 19.2,
  description:
    'Gently spicy and deeply peppery, our Cí Cí Chili Oil is cold pressed from California Arbequina olives and fresh, whole Central Coast jalapeño, Fresno, and Anaheim chilies. \n\nCí Cí is not your average chili oil. It\'s what the olio industry likes to call a "co-mill", where we actually mill fresh, whole, organic chilies and just-harvested Arbequina olives together, to create a pure chili-olive oil that reveals the complexity of each fruit. This whole-fruit co-milling method yields an oil that is vibrant, nuanced, and assertively fruit-forward. \n\nWe had pizza in mind when we made Cí Cí, but it also enlivens poached eggs, smoky eggplant, grilled salmon, fresh popcorn — and so much more.\n\nHarvested, 2025.',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:10:57.211Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
